import axios from "axios"
import { IPersonnelArretMaladieModel, IPersonnelDdcModel, IPersonnelDeclarationMensuelleModel, IPersonnelDocumentModel, IPersonnelModel } from "@common-models/*"
import {
     CONST_API_PERSONNEL_ADD_PERSONNELS_TO_TEAM_ENDPOINT,
     CONST_API_PERSONNEL_ACCOUNT_DISABLE_ACCOUNT_ENDPOINT,
     CONST_API_PERSONNEL_ACCOUNT_ENABLE_ACCOUNT_ENDPOINT,
     CONST_API_PERSONNEL_CREATE_ENDPOINT,
     CONST_API_PERSONNEL_GET_DDC_ENDPOINT,
     CONST_API_PERSONNEL_GET_MALADIES_ENDPOINT,
     CONST_API_PERSONNEL_LISTING_DETAILS_ENDPOINT,
     CONST_API_PERSONNEL_ORGANIGRAMME_ENDPOINT,
     CONST_API_PERSONNEL_POST_GET_DECLARATIONS_ENDPOINT,
     CONST_API_PERSONNEL_REMOVE_PERSONNELS_FROM_TEAM_ENDPOINT,
     CONST_API_PERSONNEL_SET_INFO_PERSO_ENDPOINT,
     CONST_API_PERSONNEL_SET_INFO_PRO_ENDPOINT,
     CONST_API_PERSONNEL_SET_CODE_ANALYTIQUE_ENDPOINT,
     CONST_API_PERSONNEL_SET_NUMERO_IMMAT_CEGEDIM_ENDPOINT,
     CONST_API_PERSONNEL_GET_SUIVIS_ENDPOINT,
     CONST_API_PERSONNEL_SET_NFC_ENDPOINT,
     CONST_API_PERSONNEL_SORTIE_DES_EFFECTIFS_ENDPOINT,
     CONST_API_PERSONNEL_SORTIE_DES_EFFECTIFS_PREVIEW_ENDPOINT,
     CONST_API_PERSONNEL_HAS_RESP_GROUP_ENDPOINT,
     CONST_API_PERSONNEL_SET_PASSWORD_ENDPOINT,
     CONST_API_AGORA_RESET_PASSWORD_ENDPOINT,
     CONST_API_PERSONNEL_ARCHIVE_CHECKLISTS_ENDPOINT,
     CONST_API_PERSONNEL_ARCHIVE_CHECKLIST_GET_ENDPOINT,
     CONST_API_PERSONNEL_ARCHIVE_CHECKLIST_TOGGLE_ENDPOINT,
     CONST_API_PERSONNEL_DE_START_ENDPOINT,
     CONST_API_PERSONNEL_DE_SET_INFO_PERSO_ENDPOINT,
     CONST_API_PERSONNEL_DE_SET_POSTE_ENDPOINT,
     CONST_API_PERSONNEL_DE_SET_TEMPS_ENDPOINT,
     CONST_API_PERSONNEL_DE_SET_FOURNISSEUR_ENDPOINT,
     CONST_API_PERSONNEL_DE_GET_DETAILS_ENDPOINT,
     CONST_API_PERSONNEL_GOOGLE_DIAGNOSTIC_ENDPOINT,
     CONST_API_PERSONNEL_GOOGLE_CREATE_ACCOUNT_ENDPOINT,
     CONST_API_PERSONNEL_GOOGLE_CREATE_GROUPS_ENDPOINT,
     CONST_API_PERSONNEL_GOOGLE_CREATE_SHARED_DRIVE_ENDPOINT,
     CONST_API_PERSONNEL_ADD_DOCUMENT_ENDPOINT,
     CONST_API_PERSONNEL_DELETE_DOCUMENT_ENDPOINT,
     CONST_API_PERSONNEL_DE_ADD_DOCUMENT_ENDPOINT,
     CONST_API_PERSONNEL_DE_DELETE_DOCUMENT_ENDPOINT,
     CONST_API_PERSONNEL_DE_SET_SANS_DIPLOME_ENDPOINT,
     CONST_API_PERSONNEL_DE_DOSSIER_PDF_ENDPOINT,
     CONST_API_PERSONNEL_DE_LISTING_ENDPOINT,
     CONST_API_PERSONNEL_DE_SOUMISSION_ENDPOINT,
     CONST_API_PERSONNEL_DE_VALIDATION_DG_ENDPOINT,
     CONST_API_PERSONNEL_DE_RECTIFICATION_DG_ENDPOINT,
     CONST_API_PERSONNEL_DE_VALIDATION_HR_ENDPOINT,
     CONST_API_PERSONNEL_DE_RECTIFICATION_HR_ENDPOINT,
     CONST_API_PERSONNEL_DE_DELETE_ENDPOINT,
     CONST_API_PERSONNEL_DE_FINALISATION_ENDPOINT,
     CONST_API_PERSONNEL_DE_DOCUMENTS_EMBAUCHE_PREVIEW_ENDPOINT,
     CONST_API_PERSONNEL_DE_DOCUMENTS_EMBAUCHE_ENVOYER_ENDPOINT,
     CONST_API_PERSONNEL_DE_DOCUMENTS_EMBAUCHE_TELECHARGER_ENDPOINT,
     CONST_API_PERSONNEL_DOCUMENTS_EMBAUCHE_PREVIEW_ENDPOINT,
     CONST_API_PERSONNEL_DOCUMENTS_EMBAUCHE_ENVOYER_ENDPOINT,
     CONST_API_PERSONNEL_DOCUMENTS_EMBAUCHE_TELECHARGER_ENDPOINT,
     CONST_API_UTILS_EXTRACT_PERSONNEL_IDENTITY_DOCUMENT_ENDPOINT,
} from "../../../endpoints"
import {
     IGetPersonnelDdcRequestModel,
     IGetPersonnelDeclarationsRequestModel,
     IGetPersonnelDetailsResponseModel,
     IGetPersonnelMaladiesRequestModel,
     IPersonnelCreateRequestModel,
     IPersonnelDEInfoPersoRequestModel,
     IPersonnelDEPosteRequestModel,
     IPersonnelDETempsRequestModel,
     IPersonnelDEFournisseurRequestModel,
     IPersonnelDEFinalizeRequestModel,
     IPersonnelDemandeEmbaucheModel,
     IPersonnelGoogleCreateAccountResponse,
     IPersonnelGoogleCreateGroupsResponse,
     IPersonnelGoogleCreateSharedDriveResponse,
     IPersonnelGoogleDiagnosticModel,
     ISetPersonnelInfoPersoRequestModel,
     ISetPersonnelInfoProRequestModel,
} from "./_models"
import { IPersonnelOrganigrammeResponse } from "../details/organigramme/PersonnelsOrganigramme"

export function getPersonnelDeclarationsRequest(id: number, payload: IGetPersonnelDeclarationsRequestModel) {
     return axios.post<IPersonnelDeclarationMensuelleModel[]>(CONST_API_PERSONNEL_POST_GET_DECLARATIONS_ENDPOINT(id), payload)
}

export function getPersonnelDdcRequest(id: number, payload: IGetPersonnelDdcRequestModel) {
     return axios.post<IPersonnelDdcModel[]>(CONST_API_PERSONNEL_GET_DDC_ENDPOINT(id), payload)
}

export function getPersonnelMaladiesRequest(id: number, payload: IGetPersonnelMaladiesRequestModel) {
     return axios.post<IPersonnelArretMaladieModel[]>(CONST_API_PERSONNEL_GET_MALADIES_ENDPOINT(id), payload)
}

export function getPersonnelDetailsRequest(id: number) {
     return axios.get<IGetPersonnelDetailsResponseModel>(CONST_API_PERSONNEL_LISTING_DETAILS_ENDPOINT(id))
}

// Une entrée du journal d'actions d'un collaborateur (PersonnelSuiviGeneral).
export interface IPersonnelSuiviGeneralModel {
     id: number
     type: string
     typeLabel: string | null
     date: string | null
     auteur: string | null
     commentaire: string | null
}

// Journal des actions effectuées sur le collaborateur.
export function getPersonnelSuivisRequest(id: number) {
     return axios.get<IPersonnelSuiviGeneralModel[]>(CONST_API_PERSONNEL_GET_SUIVIS_ENDPOINT(id))
}

// Modifie le code analytique (salarié & non salarié).
export function setPersonnelCodeAnalytiqueRequest(id: number, codeAnalytique: string) {
     return axios.post<{ codeAnalytique: string | null }>(CONST_API_PERSONNEL_SET_CODE_ANALYTIQUE_ENDPOINT(id), { codeAnalytique })
}

// Modifie le n° d'immatriculation CEGEDIM (salarié uniquement).
export function setPersonnelNumeroImmatCegedimRequest(id: number, numero: string) {
     return axios.post<{ CEGEDIM_mmat: string | null }>(CONST_API_PERSONNEL_SET_NUMERO_IMMAT_CEGEDIM_ENDPOINT(id), { numero })
}

export function getPersonnelsOrgranigrammeRequest() {
     return axios.post<IPersonnelOrganigrammeResponse>(CONST_API_PERSONNEL_ORGANIGRAMME_ENDPOINT, {})
}

export function personnelCreateRequest(payload: IPersonnelCreateRequestModel) {
     return axios.post(CONST_API_PERSONNEL_CREATE_ENDPOINT, payload)
}

// ============================ Workflow d'embauche staff (demande d'embauche) ============================

// Construit un multipart : `data` = JSON (types préservés) + `avatar` = fichier éventuel.
function buildInfoPersoFormData(payload: IPersonnelDEInfoPersoRequestModel): FormData {
     const { avatar, ...data } = payload
     const formData = new FormData()
     formData.append("data", JSON.stringify(data))
     if (avatar) formData.append("avatar", avatar)
     return formData
}

// Démarre la demande (étape Identité & contact) — retourne la demande créée (avec son id).
export function personnelDEStartRequest(payload: IPersonnelDEInfoPersoRequestModel) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_START_ENDPOINT, buildInfoPersoFormData(payload))
}

export function personnelDESetInfoPersoRequest(demandeId: number, payload: IPersonnelDEInfoPersoRequestModel) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_SET_INFO_PERSO_ENDPOINT(demandeId), buildInfoPersoFormData(payload))
}

export function personnelDESetPosteRequest(demandeId: number, payload: IPersonnelDEPosteRequestModel) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_SET_POSTE_ENDPOINT(demandeId), payload)
}

export function personnelDESetTempsRequest(demandeId: number, payload: IPersonnelDETempsRequestModel) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_SET_TEMPS_ENDPOINT(demandeId), payload)
}

export function personnelDESetFournisseurRequest(demandeId: number, payload: IPersonnelDEFournisseurRequestModel) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_SET_FOURNISSEUR_ENDPOINT(demandeId), payload)
}

export function personnelDEGetDetailsRequest(demandeId: number) {
     return axios.get<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_GET_DETAILS_ENDPOINT(demandeId))
}

export function personnelDEAddDocumentRequest(demandeId: number, type: string, fichier: File) {
     const formData = new FormData()
     formData.append("fichier", fichier)
     formData.append("type", type)
     return axios.post(CONST_API_PERSONNEL_DE_ADD_DOCUMENT_ENDPOINT(demandeId), formData)
}

export function personnelDEDeleteDocumentRequest(demandeId: number, documentId: number) {
     return axios.delete(CONST_API_PERSONNEL_DE_DELETE_DOCUMENT_ENDPOINT(demandeId, documentId))
}

// Champs d'identité prérremplis renvoyés par l'IA (uniquement les champs détectés ; selects = {id, label}).
export interface IPersonnelIdentityExtractionModel {
     fields: {
          nSecuriteSociale?: string
          civilite?: string
          nom?: string
          prenom?: string
          dateNaissance?: string
          paysNaissance?: { id: number; label: string }
          isNationaliteEtrangere?: boolean
          nationalite?: { id: number; label: string }
          residenceAdresse?: string
          residenceCodePostal?: string
          residenceVille?: string
          residencePays?: { id: number; label: string }
          residenceVilleFrance?: { id: number; label: string }
          telPersonnel?: string
          telPersonnelIndicatif?: { id: number; label: string }
          mailPersonnel?: string
     }
}

// Extraction IA (stateless) des infos d'identité d'un document d'embauche (Attestation SS / Passeport-CNI / CV).
export function personnelExtractIdentityDocumentRequest(type: string, fichier: File) {
     const formData = new FormData()
     formData.append("fichier", fichier)
     formData.append("type", type)
     return axios.post<IPersonnelIdentityExtractionModel>(CONST_API_UTILS_EXTRACT_PERSONNEL_IDENTITY_DOCUMENT_ENDPOINT, formData)
}

// Déclare (ou annule) l'absence de diplôme du collaborateur — rend le document Diplôme facultatif à la soumission.
export function personnelDESetSansDiplomeRequest(demandeId: number, sansDiplome: boolean) {
     return axios.post(CONST_API_PERSONNEL_DE_SET_SANS_DIPLOME_ENDPOINT(demandeId), { sansDiplome })
}

// Dossier complet PDF (fiche récapitulative + tous les documents fusionnés). Réponse binaire (blob).
export function personnelDEDossierPdfRequest(demandeId: number) {
     return axios.get<Blob>(CONST_API_PERSONNEL_DE_DOSSIER_PDF_ENDPOINT(demandeId), { responseType: "blob" })
}

// Une ligne du journal d'activité liée à l'envoi des documents d'embauche.
export interface IPersonnelDEDocumentsEmbaucheSuiviModel {
     type: string
     typeLabel: string | null
     date: string | null
     auteur: string | null
     commentaire: string | null
}

// Un document du dossier Drive de l'entité (consultable via son id Drive). name = titre (DocumentEmbauche).
export interface IPersonnelDocumentsEmbaucheFileModel {
     googleDriveID: string
     name: string | null
     fileName?: string | null
     mimeType: string | null
     size: number | null
}

// Aperçu de la page « Envoyer les documents d'embauche » (salarié en configuration IT).
export interface IPersonnelDEDocumentsEmbauchePreviewModel {
     entite: string | null
     statut: string | null
     mailPersonnel: string | null
     documentsEntite: IPersonnelDocumentsEmbaucheFileModel[]
     contratDisponible: boolean
     contratSize?: number | null
     maxEmailSize?: number
     suivis: IPersonnelDEDocumentsEmbaucheSuiviModel[]
}
export function personnelDEDocumentsEmbauchePreviewRequest(demandeId: number) {
     return axios.get<IPersonnelDEDocumentsEmbauchePreviewModel>(CONST_API_PERSONNEL_DE_DOCUMENTS_EMBAUCHE_PREVIEW_ENDPOINT(demandeId))
}

// Envoie les documents d'embauche à l'email personnel du collaborateur (contrat inclus par défaut).
export function personnelDEEnvoyerDocumentsEmbaucheRequest(demandeId: number, contratInclus: boolean) {
     return axios.post(CONST_API_PERSONNEL_DE_DOCUMENTS_EMBAUCHE_ENVOYER_ENDPOINT(demandeId), { contratInclus })
}

// Télécharge le ZIP des documents d'embauche (+ contrat selon contratInclus). Réponse binaire (blob).
export function personnelDETelechargerDocumentsEmbaucheRequest(demandeId: number, contratInclus: boolean) {
     return axios.get<Blob>(CONST_API_PERSONNEL_DE_DOCUMENTS_EMBAUCHE_TELECHARGER_ENDPOINT(demandeId), {
          responseType: "blob",
          params: { contratInclus: contratInclus ? 1 : 0 },
     })
}

// --- Documents d'embauche d'un collaborateur déjà intégré (onglet Documents de la fiche staff) ---

// Aperçu de la section « Documents d'embauche » (dossier de l'entité — sans le contrat de travail).
export interface IPersonnelDocumentsEmbauchePreviewModel {
     entite: string | null
     statut: string | null
     mailPersonnel: string | null
     documentsEntite: IPersonnelDocumentsEmbaucheFileModel[]
     maxEmailSize?: number
     suivis: IPersonnelDEDocumentsEmbaucheSuiviModel[]
}
export function personnelDocumentsEmbauchePreviewRequest(personnelId: number) {
     return axios.get<IPersonnelDocumentsEmbauchePreviewModel>(CONST_API_PERSONNEL_DOCUMENTS_EMBAUCHE_PREVIEW_ENDPOINT(personnelId))
}

// Envoie les documents d'embauche du dossier de l'entité à l'email personnel du collaborateur.
export function personnelEnvoyerDocumentsEmbaucheRequest(personnelId: number) {
     return axios.post(CONST_API_PERSONNEL_DOCUMENTS_EMBAUCHE_ENVOYER_ENDPOINT(personnelId), {})
}

// Télécharge le ZIP des documents d'embauche du dossier de l'entité. Réponse binaire (blob).
export function personnelTelechargerDocumentsEmbaucheRequest(personnelId: number) {
     return axios.get<Blob>(CONST_API_PERSONNEL_DOCUMENTS_EMBAUCHE_TELECHARGER_ENDPOINT(personnelId), { responseType: "blob" })
}

// Diagnostic Google Workspace (compte, groupes GWS, Drive partagés) — réservé à la gestion staff complète.
export function personnelGoogleDiagnosticRequest(personnelId: number) {
     return axios.get<IPersonnelGoogleDiagnosticModel>(CONST_API_PERSONNEL_GOOGLE_DIAGNOSTIC_ENDPOINT(personnelId))
}

// Crée le compte Google du collaborateur (renvoie le mot de passe temporaire).
export function personnelGoogleCreateAccountRequest(personnelId: number) {
     return axios.post<IPersonnelGoogleCreateAccountResponse>(CONST_API_PERSONNEL_GOOGLE_CREATE_ACCOUNT_ENDPOINT(personnelId), {})
}

// Crée les groupes GWS manquants (équipe / hiérarchie) — nécessite un compte Google.
export function personnelGoogleCreateGroupsRequest(personnelId: number) {
     return axios.post<IPersonnelGoogleCreateGroupsResponse>(CONST_API_PERSONNEL_GOOGLE_CREATE_GROUPS_ENDPOINT(personnelId), {})
}

// Crée un Drive partagé « Prénom NOM » (gestionnaire de contenu = groupe hiérarchie).
export function personnelGoogleCreateSharedDriveRequest(personnelId: number) {
     return axios.post<IPersonnelGoogleCreateSharedDriveResponse>(CONST_API_PERSONNEL_GOOGLE_CREATE_SHARED_DRIVE_ENDPOINT(personnelId), {})
}

// Documents d'un collaborateur déjà intégré (fiche staff). La suppression est un soft delete côté serveur.
export function personnelAddDocumentRequest(personnelId: number, type: string, fichier: File) {
     const formData = new FormData()
     formData.append("fichier", fichier)
     formData.append("type", type)
     return axios.post<IPersonnelDocumentModel>(CONST_API_PERSONNEL_ADD_DOCUMENT_ENDPOINT(personnelId), formData)
}

export function personnelDeleteDocumentRequest(personnelId: number, documentId: number) {
     return axios.delete(CONST_API_PERSONNEL_DELETE_DOCUMENT_ENDPOINT(personnelId, documentId))
}

// ---- Transitions + listing (phase 3) ----
export function personnelDEListingRequest() {
     return axios.get<IPersonnelDemandeEmbaucheModel[]>(CONST_API_PERSONNEL_DE_LISTING_ENDPOINT)
}

export function personnelDESoumettreRequest(demandeId: number, commentaire?: string) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_SOUMISSION_ENDPOINT(demandeId), { commentaire })
}

export function personnelDEValiderDgRequest(demandeId: number, commentaire?: string) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_VALIDATION_DG_ENDPOINT(demandeId), { commentaire })
}

export function personnelDERectifierDgRequest(demandeId: number, commentaire: string) {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_RECTIFICATION_DG_ENDPOINT(demandeId), { commentaire })
}

export function personnelDEValiderHrRequest(demandeId: number, contrat?: File) {
     const formData = new FormData()
     if (contrat) formData.append("contrat", contrat)
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_VALIDATION_HR_ENDPOINT(demandeId), formData)
}

export function personnelDERectifierHrRequest(demandeId: number, commentaire: string, cible: "creator" | "dg") {
     return axios.post<IPersonnelDemandeEmbaucheModel>(CONST_API_PERSONNEL_DE_RECTIFICATION_HR_ENDPOINT(demandeId), { commentaire, cible })
}

export function personnelDESupprimerRequest(demandeId: number) {
     return axios.delete(CONST_API_PERSONNEL_DE_DELETE_ENDPOINT(demandeId))
}

export function personnelDEFinaliserRequest(demandeId: number, payload: IPersonnelDEFinalizeRequestModel) {
     return axios.post(CONST_API_PERSONNEL_DE_FINALISATION_ENDPOINT(demandeId), payload)
}

export function setInfoPersoPersonnelRequest(id: number, payload: ISetPersonnelInfoPersoRequestModel) {
     const formData = new FormData()

     for (const [key, value] of Object.entries(payload)) {
          // On n'envoie pas les champs vides : FormData sérialiserait `undefined` en chaîne "undefined",
          // ce qui casse la désérialisation des propriétés typées côté serveur (ex : ?DateTime, ?Pays) pour un non salarié.
          if (value === undefined || value === null) continue
          if (key !== "avatar") formData.append(`data[${key}]`, value)
          if (key === "avatar") formData.append(`avatar`, value)
     }

     return axios.post<IGetPersonnelDetailsResponseModel>(CONST_API_PERSONNEL_SET_INFO_PERSO_ENDPOINT(id), formData)
}

export function setInfoPersoProRequest(id: number, payload: ISetPersonnelInfoProRequestModel) {
     return axios.post<IGetPersonnelDetailsResponseModel>(CONST_API_PERSONNEL_SET_INFO_PRO_ENDPOINT(id), payload)
}

export function personnelAddPersonnelsToTeamRequest(id: number, personnelsToAdd: number[]) {
     return axios.post<IGetPersonnelDetailsResponseModel>(CONST_API_PERSONNEL_ADD_PERSONNELS_TO_TEAM_ENDPOINT(id), { personnelsToAdd })
}

export function personnelRemovePersonnelsFromTeamRequest(id: number, personnelsToRemove: number[]) {
     return axios.post<IGetPersonnelDetailsResponseModel>(CONST_API_PERSONNEL_REMOVE_PERSONNELS_FROM_TEAM_ENDPOINT(id), { personnelsToRemove })
}

export function personnelEnableAccountRequest(id: number) {
     return axios.post(CONST_API_PERSONNEL_ACCOUNT_ENABLE_ACCOUNT_ENDPOINT(id), {})
}

export function personnelDisableAccountRequest(id: number, dateFinAccess: string) {
     return axios.post(CONST_API_PERSONNEL_ACCOUNT_DISABLE_ACCOUNT_ENDPOINT(id), { dateFinAccess })
}

export function personnelSetNfcRequest(id: number, nfc_id: number | null) {
     return axios.post<IPersonnelModel>(CONST_API_PERSONNEL_SET_NFC_ENDPOINT(id), { nfc: nfc_id })
}

export interface IPersonnelSortiePreviewModel {
     nbConsultants: number
     nbStandalonePropals: number
     nbAnnonces: number
     nbViviers: number
     hasSubordinates: boolean
     isRoot: boolean
}

export interface IPersonnelSortieRequestModel {
     dateSortie: string
     responsable?: number | null
     remplacantHierarchique?: number | null
}

export function personnelSortieDesEffectifsPreviewRequest(id: number) {
     return axios.get<IPersonnelSortiePreviewModel>(CONST_API_PERSONNEL_SORTIE_DES_EFFECTIFS_PREVIEW_ENDPOINT(id))
}

export function personnelSortieDesEffectifsRequest(id: number, payload: IPersonnelSortieRequestModel) {
     return axios.post(CONST_API_PERSONNEL_SORTIE_DES_EFFECTIFS_ENDPOINT(id), payload)
}

export function personnelHasRespGroupRequest(id: number) {
     return axios.get<{ hasRespGroup: boolean }>(CONST_API_PERSONNEL_HAS_RESP_GROUP_ENDPOINT(id))
}

export function personnelSetPasswordRequest(id: number, payload: { password?: string; generate?: boolean }) {
     return axios.post(CONST_API_PERSONNEL_SET_PASSWORD_ENDPOINT(id), payload)
}

// Changement de son propre mot de passe (utilisateur connecté) — utilisé pour le changement forcé
export function changeMyPasswordRequest(password: string) {
     return axios.put(CONST_API_AGORA_RESET_PASSWORD_ENDPOINT, { password })
}

// ---- Checklists post-archivage (ROLE_SUPER_ADMIN / ROLE_IT)
export interface IArchiveChecklistListItemModel {
     id: number
     personnelNom: string
     gwsEmail: string | null
     createdAt: string
     nbDone: number
     nbTotal: number
}

export interface IArchiveChecklistDetailModel {
     id: number
     personnelNom: string
     gwsEmail: string | null
     gwsGroupEmails: string[]
     tasks: Record<string, boolean>
     createdAt: string
     completedAt: string | null
}

export function personnelArchiveChecklistsRequest() {
     return axios.get<IArchiveChecklistListItemModel[]>(CONST_API_PERSONNEL_ARCHIVE_CHECKLISTS_ENDPOINT)
}

export function personnelArchiveChecklistGetRequest(id: number) {
     return axios.get<IArchiveChecklistDetailModel>(CONST_API_PERSONNEL_ARCHIVE_CHECKLIST_GET_ENDPOINT(id))
}

export function personnelArchiveChecklistToggleRequest(id: number, task: string, done: boolean) {
     return axios.post<{ tasks: Record<string, boolean>; completedAt: string | null }>(CONST_API_PERSONNEL_ARCHIVE_CHECKLIST_TOGGLE_ENDPOINT(id), { task, done })
}
